import SidebarBookingsSummaryAcceptRoute from 'uplisting-frontend/pods/-sidebar/bookings/summary/accept/route';

export default class ProtectionOverviewBookingsSummaryAcceptRoute extends SidebarBookingsSummaryAcceptRoute {
  parentRoute = 'protection.overview.bookings';
  summaryRoute = 'protection.overview.bookings.summary';
}
